// userData.ts
import { UserProfile, RecentAction } from './Types';

export const userProfiles: Record<string, UserProfile> = {
  '1': {
    name: 'Rahul Doshi',
    position: 'Interim Head - Finance',
    department: 'Finance - Dept',
    avatar: 'assets/org-chart-profile-one.svg',
    coverImage: 'assets/user-cover.svg',
    pronouns: 'He/His',
    location: 'KANAKAPURA (TQ)',
    experience: '34 Yrs Experience',
    bio: 'Hi I am Rahul Doshi',
    workingSince: 'I am working At AOS - Since 2015'
  },
  '2': {
    name: 'Gourav Kumar Gupta',
    position: 'Deputy Manager - AR',
    department: 'Finance - Dept',
    avatar: 'assets/org-chart-profile-two.svg',
    coverImage: 'assets/user-cover.svg',
    pronouns: 'He/His',
    location: 'KANAKAPURA (TQ)',
    experience: '8 Yrs Experience',
    bio: 'Hi I am Gourav Kumar Gupta',
    workingSince: 'I am working At AOS - Since 2016'
  },
  '3': {
    name: 'Harsha Stephen',
    position: 'Deputy Manager - Finance',
    department: 'Finance - Dept',
    avatar: 'assets/org-chart-profile-three.svg',
    coverImage: 'assets/user-cover.svg',
    pronouns: 'He/His',
    location: 'KANAKAPURA (TQ)',
    experience: '12 Yrs Experience',
    bio: 'Hi I am Harsha Stephen',
    workingSince: 'I am working At AOS - Since 2012'
  },
  '4': {
    name: 'Dhaval Atul Parikh',
    position: 'Manager - Finance',
    department: 'Finance - Dept',
    avatar: 'assets/org-chart-profile-four.svg',
    coverImage: 'assets/user-cover.svg',
    pronouns: 'He/His',
    location: 'KANAKAPURA (TQ)',
    experience: '15 Yrs Experience',
    bio: 'Hi I am Dhaval Atul Parikh',
    workingSince: 'I am working At AOS - Since 2009'
  }
};

export const recentActions: RecentAction[] = [
  { title: 'Review AOS PDF', type: 'pdf' as const },
  { title: 'Design Review', type: 'design' as const },
  { title: 'Review AOS PDF', type: 'review' as const }
];